//Student.jsx
import { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { getOrcidId, getOrcidProfileUrl } from "../utils/orcid";

export const Student = (props) =>{
	const navigate = useNavigate();
    const {studentId} = useParams();
    const student = props.students.find( (student) => student.id === studentId );
    const [orcidCopied, setOrcidCopied] = useState(false);

    if (!student)
    {
    	return null;
    }

	const researchLine = (student.linea_investigacion) ? props.researchLines.find( (researchLine) => researchLine.id === student.linea_investigacion ) : null;
    const subResearchLine = (student.sub_linea_investigacion) ? props.subResearchLines.find( (subResearchLine) => subResearchLine.id === student.sub_linea_investigacion ) : null;
    const orcidId = getOrcidId(student.orcidid);
    const orcidUrl = getOrcidProfileUrl(student.orcidid);

    const copyOrcidId = async () => {
        if (!orcidId) return;
        try {
            await navigator.clipboard.writeText(orcidId);
            setOrcidCopied(true);
            setTimeout(() => setOrcidCopied(false), 2000);
        } catch {
            window.prompt('Copia el ORCID iD:', orcidId);
        }
    };

    return(
    	<div className="p-4 col-md-12">
    		<div className="card">
    			<div className="card-header d-flex justify-content-between align-items-center flex-wrap gap-2">
    				<h2 className="mb-0 d-flex align-items-center flex-wrap gap-2 gap-md-3">
    					<button className="btn btn-danger" type="button" onClick={() => navigate(-1)}>Regresar</button>
    					<span className="d-inline-flex align-items-center flex-wrap gap-2">
    						<span>{student.name}</span>
    						{orcidId && (
    							<span className="d-inline-flex align-items-center flex-wrap gap-2">
    								<span className="text-secondary" aria-hidden="true">&bull;</span>
    								<code
    									className="bg-light px-2 py-1 rounded user-select-all"
    									style={{ fontSize: '0.9em' }}
    									title="ORCID iD (selecciona para copiar)"
    								>
    									{orcidId}
    								</code>
    								<button
    									type="button"
    									className="btn btn-sm btn-outline-secondary py-0"
    									onClick={copyOrcidId}
    								>
    									{orcidCopied ? 'Copiado' : 'Copiar'}
    								</button>
    								{orcidUrl && (
    									<>
    										{/* eslint-disable-next-line react/jsx-no-target-blank */}
    										<a target="_blank" rel="noreferrer" href={orcidUrl} className="h6 mb-0">
    											Ir
    										</a>
    									</>
    								)}
    							</span>
    						)}
    					</span>
    				</h2>
    			</div>
	    		<div className="card-body">
	    			<div className="row">
	    				<div className="col-10">
		    				<h3>{student.carrera}</h3>
							<h4>{researchLine ? researchLine.name : ''}{ subResearchLine ? ' (' + subResearchLine.titulo + ')' : '' }</h4>
	    				</div>
	    				<div className="col">
	    					<img id='id-img-alumn' loading="lazy" style={{height:"7em", 'padding': "0", 'margin': "0"}} className= "img-fluid foto-alumno card-img-top-center" src={ (student.url_imagen) ? student.url_imagen : ( !student.foto ?  require('../assets/fotos/unknown.png') : require('../assets/fotos/' + student.foto)) } alt="Alumno" />
		    			</div>
		    		</div>
		    		<div>
		    			{
		    				( student.semblanzas && student.semblanzas.length > 0 )
				    		?
					    		(
					    			<div>
						    			<h3>Semblanza</h3>
							    		{
							    			student.semblanzas.map((semblanza, idx) => (<p key={idx} style={{"textAlign":"justify"}}>{semblanza.descripcion}</p>) )
							    		}
							    	</div>
						    	)
					    	:
					    		null
				    	}
			    	</div>
		            <div>
		                <div className="row">
		                	<div className="col">
		                    {
		                        ( props.projectTypes && props.projectTypes.length > 0 && student.proyecto.length >= 1 ) 
		                        ? 
		                        	(<ul className="list-group">
		                            	{
		                                	props.projectTypes.map( (item, id) => {
		                                    	let filterType = student.proyecto.filter( proyect => proyect.type === item.type );
		                                        if (!filterType.length) {
		                                        	return (
		                                            	null
		                                            )
		                                        } else {
		                                        	return (
		                                            	<li key={id} className="list-group-item">
		                                                	<h3>{ ( filterType.length > 1 ) ? item.title_multi : item.title }</h3>
		                                                    <ul className="list-group">
		                                                    {
		                                                    	filterType.map( (proyect, idx) => (
		                                                        	(proyect.url) 
		                                                            ?
		                                                            	<li key={idx} className="list-group-item">
		                                                            	{/* eslint-disable-next-line react/jsx-no-target-blank */}
		                                                            	<a target="_blank" rel="noreferrer" href={proyect.url}>{proyect.proyecto}</a>
		                                                            </li>
		                                                            :
		                                                            	<li key={idx} className="list-group-item">{proyect.proyecto}</li>
		                                                            ))
		                                                    }
		                                                    </ul>
		                                                </li>
		                                            )
		                                        }
		                                    })
		                                }
		                            </ul>)
		                        :
		                        	null
		                    }
		                	</div>
		            	</div>
		            </div>
		        </div>
		    </div>
    	</div>
    )
}
